module.exports = __webpack_public_path__ + "static/img/GAGNANZHOU.e717ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/GAGNANZHOU.png
// module id = 1i9f
// module chunks = 1